let blockFormFieldsToggle = {
    watch: {
        '$validator.errors': {
            handler: function (errorBag) {
                if (!this.watchOnBlocks) throw Error('Configuration for block and fields do not specified.');

                this.watchOnBlocks.forEach((i) => {
                    if (!i.fields) throw Error(`Configuration or reference for fields of block "${i.ref.$options._componentTag}" do not specified.`);

                    i.fields.forEach((f) => {
                        if (errorBag.has(f)) {
                            i.ref.open();
                        }
                    });
                });
            },
            deep: true
        }
    }
};

export default blockFormFieldsToggle;
